"use strict";

module.exports = ["#eee", "#d6e685", "#8cc665", "#44a340", "#1e6823"];


//////////////////
// WEBPACK FOOTER
// ./~/github-calendar-legend/lib/index.js
// module id = 21
// module chunks = 0